import styled from 'styled-components';
import { lightGrey2Color, blueColor } from 'js/config/style';

import { background } from './Button';
const radiusSize = '0.25rem';

export default styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  background: ${background};
  padding: 0.5rem 0;
  border-radius: 0 ${radiusSize} ${radiusSize} ${radiusSize};
  border-top: 1px solid ${lightGrey2Color};
  border-right: 1px solid ${lightGrey2Color};
  z-index: 1;
  display: ${({ open }) => (open ? 'grid' : 'none')};
  grid-row-gap: 0.25rem;
  font-size: 0.8rem;
  cursor: auto;
  box-shadow: 0 4px 13px -5px rgba(0, 0, 0, 0.6);
  margin-top: -1px;

  & > a {
    display: block;
    color: black;
    font-weight: 500;
    background: transparent;
    white-space: nowrap;
    padding: 0 1rem;
    min-width: 150px;

    &:hover,
    &:focus,
    &.active {
      background: ${blueColor};
      color: white;
      text-decoration: none;
    }
  }
`;
